export const ScreenState = {
    MOBILE: "(max-width: 767px)",
    TABLET: "(min-width: 768px) and (max-width: 991px)",
    DESKTOP: "(min-width: 992px)"
};
